import ViewAnnouncements from "../components/Announcement/ViewAnnouncement";

const AnnouncementsPage: React.FC = () => {
  return <ViewAnnouncements />;
};

export default AnnouncementsPage;
